import { ReactNode } from 'react';

type Props = {
  children?: ReactNode;
  title: string;
};

export default function FormCardWrapper({ children, title }: Props) {
  return (
    <div className='max-w-[720px] w-full mx-auto'>
      <h1 className="blockH3 font-bold text-orange text-center">{title}</h1>
      {children}
    </div>
  );
}
